<template>
  <mychart :options="options" v-if="options !== null" :chartID ="chartid"></mychart>
</template>
<script>
import mychart from './Chart'

function stat (res) {
  let data = res.map(d => {
    let newData = {}
    newData.death = d.status === 'dead' ? 1 : 0
    newData.month = Math.ceil(d.days / 30)
    return newData
  })
  data = data.sort(
    (a, b) => (a.month === b.month ? a.death - b.death : a.month - b.month)
  )
  // console.table(data)
  data = data.filter(
    (item, pos, ary) =>
      !pos || JSON.stringify(item) !== JSON.stringify(ary[pos - 1])
  )
  // console.table(data)
  data = data.map((d, index, ary) => {
    d.c = res.filter(item => Math.ceil(item.days / 30) >= d.month).length
    d.c_Dead = res.filter(
      item => Math.ceil(item.days / 30) === d.month && item.status === 'dead'
    ).length
    d.c_lost = res.filter(
      item => Math.ceil(item.days / 30) === d.month && item.status !== 'dead'
    ).length
    d.p_sur = 1 - d.c_Dead / d.c
    d.p = (index === 0 ? d.p_sur : ary[index - 1].p * d.p_sur).toFixed(3)
    // console.table(d)
    return [d.month, d.p]
  })
  // console.table(data)
  return data
}

function KMData (caseinfo) {
  // console.log(caseinfo)
  let mid // 中位数
  let data = caseinfo.map(d => d.exprcount)
  data.sort((a, b) => b - a) // 数组排序
  if (data.length % 2 === 0) {
    mid =
      (Number(data[data.length / 2]) + Number(data[data.length / 2 + 1])) / 2
  }
  if (data.length % 2 !== 0) {
    mid = data[(data.length + 1) / 2]
  }
  // console.log(mid)
  let low = caseinfo.filter(d => Number(d.exprcount) <= mid)
  let high = caseinfo.filter(d => Number(d.exprcount) > mid)
  // console.log(high.map(d=>d.days))
  // console.table((high))
  // console.table(stat(low))
  // console.table(stat(high))
  return [stat(low), stat(high)]
}

export default {
  components: { mychart },
  name: 'KMCurve',
  props: ['surData'],
  data: () => ({
    options: {},
    chartid: Math.random() * 100000000000000000
  }),
  mounted () {
    // console.log(this.surData)
    this.KMCurve()
  },
  watch: {
    surData: function () {
      this.KMCurve()
    }
  },
  methods: {
    KMCurve: function () {
      let data = KMData(this.surData)
      this.options = {
        title: {
          text: 'Survival Curve'
        },
        tooltip: { trigger: 'axis' },
        legend: {
          data: ['High express', 'Low express']
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '15%'
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'value',
          max: v => Math.min(v.max, 1300),
          name: 'months',
          nameLocation: 'center',
          nameGap: 45
        },
        yAxis: {
          type: 'value',
          min: v => Math.max(v.min - 0.05, 0).toFixed(1),
          name: 'Probability of Survival',
          nameLocation: 'center',
          nameGap: 45
        },
        series: [
          {
            name: 'Low express',
            type: 'line',
            step: 'start',
            data: data[0],
            showSymbol: false
          },
          {
            name: 'High express',
            type: 'line',
            step: 'start',
            data: data[1],
            showSymbol: false
          }
        ],
        color: ['#0aa344', '#dc3023']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/KMCurve.vue